module.exports = __webpack_public_path__ + "img/f25c036.svg";